import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { LAYER, useSmartClosePopups } from 'js/components/common/PopupManager';
import { closePopupsAction } from 'js/components/common/PopupManager/store/actions';
import { showChangePasswordPopupAction } from 'js/components/popups/ChangePasswordPopup';

import { VALIDATION_TYPE } from '../constants';

export const useValidatePasswordChange = () => {
    const dispatch = useDispatch();
    const closePopups = useSmartClosePopups();

    return useCallback((pasLoginResponse) => new Promise((resolve, reject) => {
        const { sessionValidationData = {} } = pasLoginResponse?.data || {};

        if (!sessionValidationData.SessionValidationByPasswordChangeData) {
            resolve();

            return;
        }

        let isValid = false;
        const { requiredFields = 'newPassword' } = sessionValidationData.SessionValidationByPasswordChangeData[0] || {};
        const showOldPassword = requiredFields
            .split(',')
            .map(field => field.trim())
            .includes('oldPassword');

        dispatch(showChangePasswordPopupAction({
            id: VALIDATION_TYPE.CHANGE_PASSWORD,
            showOldPassword,
            onSuccess: () => {
                isValid = true;
                dispatch(closePopupsAction({ popups: [VALIDATION_TYPE.CHANGE_PASSWORD] }));
                resolve();
            },
            onClose: () => {
                if (!isValid) {
                    closePopups({ excludeLayers: [LAYER.LOGIN] });
                    reject(pasLoginResponse);
                }
            }
        }));
    }), [closePopups, dispatch]);
};
